<template>
	<nav class="footer-nav">
		<ul class="list-reset">
			<li>
				<a href="https://twitter.com/leadgemio">Twitter</a>
			</li>
			<li>
				<a href="/policies#">Policies</a>
			</li>
			<li>
				<a href="mailto:support@leadgem.io">Contact</a>
			</li>
		</ul>
	</nav>
</template>

<script>
export default {
	name: "CFooterNav",
};
</script>
